import { useEffect, useRef, useState } from "react";
import { Button, Tag, Typography } from "antd";
import { FaTimes } from "react-icons/fa";

import { IContaComErro } from "../../../../../interfaces";

interface IProps {
    conta: IContaComErro;
    onClickToggleContaAtiva?: (params: { contaId: number, ativa: boolean }) => Promise<void>;
    isManutencao?: boolean;
}

export default function ContaComErro({
    conta,
    onClickToggleContaAtiva,
    isManutencao = false,
}: IProps) {
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const isMounted = useRef(false);

    const handleClickToggleContaAtiva = async () => {
        if (!onClickToggleContaAtiva) {
            return;
        }

        setIsLoading(true);

        await onClickToggleContaAtiva({ contaId: conta.id, ativa: !conta.ativa });

        if (isMounted.current) {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        isMounted.current = true;

        return () => {
            isMounted.current = false;
        }
    }, []);

    // No momento, vai ser permitido apenas inativar, mas futuramente vai existir a ação de ativar novamente
    const mostrarBotaoToggleContaAtiva = !isManutencao && conta.ativa;

    return (
        <div
            style={{
                display: 'flex',
                alignItems: 'center',
                gap: 8,
                padding: 8,
            }}
        >
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 12,
                }}
            >
                <div
                    style={{
                        width: 24,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        marginRight: -6
                    }}
                >
                    <FaTimes color="#FF4747" />
                </div>

                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        flexWrap: 'wrap',
                        columnGap: 12,
                    }}
                >
                    <Typography.Text type={conta.com_erro_integracao ? undefined : "secondary"}>
                        {'Conta: '}

                        <Typography.Text style={{ color: conta.com_erro_integracao ? "#FF4747" : undefined }}>
                            {conta.numero}
                        </Typography.Text>
                    </Typography.Text>

                    <Typography.Text type={conta.com_erro_integracao ? undefined : "secondary"}>
                        {'Agência: '}

                        <Typography.Text style={{ color: conta.com_erro_integracao ? "#FF4747" : undefined }}>
                            {conta.agencia}
                        </Typography.Text>
                    </Typography.Text>
                </div>

                {
                    conta.com_erro_integracao && (
                        <Tag color="error" style={{ borderRadius: 4 }}>
                            Com erro
                        </Tag>
                    )
                }
            </div>

            {
                mostrarBotaoToggleContaAtiva && (
                    <Button
                        type={conta.ativa ? "primary" : "ghost"}
                        onClick={handleClickToggleContaAtiva}
                        danger={conta.ativa}
                        disabled={isLoading}
                        loading={isLoading}
                        style={{
                            borderRadius: 4,
                            padding: '0 6px',
                        }}
                    >
                        {conta.ativa ? "Inativar" : "Ativar"}
                    </Button>
                )
            }
        </div>
    )
}
